export default __webpack_public_path__ + "static/media/carnation.5bda8b2f.jpg";